__turbopack_context__.v({
  "active": "wpforms-module__ZqAQqG__active",
  "amp-form-submit-success": "wpforms-module__ZqAQqG__amp-form-submit-success",
  "before": "wpforms-module__ZqAQqG__before",
  "choices": "wpforms-module__ZqAQqG__choices",
  "choices__inner": "wpforms-module__ZqAQqG__choices__inner",
  "choices__input": "wpforms-module__ZqAQqG__choices__input",
  "choices__list--dropdown": "wpforms-module__ZqAQqG__choices__list--dropdown",
  "choices__list--single": "wpforms-module__ZqAQqG__choices__list--single",
  "circles": "wpforms-module__ZqAQqG__circles",
  "connector": "wpforms-module__ZqAQqG__connector",
  "hover": "wpforms-module__ZqAQqG__hover",
  "inline-fields": "wpforms-module__ZqAQqG__inline-fields",
  "is-flipped": "wpforms-module__ZqAQqG__is-flipped",
  "is-focused": "wpforms-module__ZqAQqG__is-focused",
  "is-open": "wpforms-module__ZqAQqG__is-open",
  "placeholder": "wpforms-module__ZqAQqG__placeholder",
  "progress": "wpforms-module__ZqAQqG__progress",
  "rtl": "wpforms-module__ZqAQqG__rtl",
  "selected": "wpforms-module__ZqAQqG__selected",
  "user-invalid": "wpforms-module__ZqAQqG__user-invalid",
  "wp-editor-area": "wpforms-module__ZqAQqG__wp-editor-area",
  "wpforms-captcha-equation": "wpforms-module__ZqAQqG__wpforms-captcha-equation",
  "wpforms-captcha-math": "wpforms-module__ZqAQqG__wpforms-captcha-math",
  "wpforms-captcha-question": "wpforms-module__ZqAQqG__wpforms-captcha-question",
  "wpforms-checkbox-2-columns": "wpforms-module__ZqAQqG__wpforms-checkbox-2-columns",
  "wpforms-checkbox-3-columns": "wpforms-module__ZqAQqG__wpforms-checkbox-3-columns",
  "wpforms-clear": "wpforms-module__ZqAQqG__wpforms-clear",
  "wpforms-close": "wpforms-module__ZqAQqG__wpforms-close",
  "wpforms-close-left": "wpforms-module__ZqAQqG__wpforms-close-left",
  "wpforms-close-right": "wpforms-module__ZqAQqG__wpforms-close-right",
  "wpforms-confirmation-container-full": "wpforms-module__ZqAQqG__wpforms-confirmation-container-full",
  "wpforms-container-full": "wpforms-module__ZqAQqG__wpforms-container-full",
  "wpforms-datepicker-clear": "wpforms-module__ZqAQqG__wpforms-datepicker-clear",
  "wpforms-datepicker-wrap": "wpforms-module__ZqAQqG__wpforms-datepicker-wrap",
  "wpforms-delete": "wpforms-module__ZqAQqG__wpforms-delete",
  "wpforms-description": "wpforms-module__ZqAQqG__wpforms-description",
  "wpforms-disclaimer-description": "wpforms-module__ZqAQqG__wpforms-disclaimer-description",
  "wpforms-error": "wpforms-module__ZqAQqG__wpforms-error",
  "wpforms-error-alert": "wpforms-module__ZqAQqG__wpforms-error-alert",
  "wpforms-error-container": "wpforms-module__ZqAQqG__wpforms-error-container",
  "wpforms-error-noscript": "wpforms-module__ZqAQqG__wpforms-error-noscript",
  "wpforms-field": "wpforms-module__ZqAQqG__wpforms-field",
  "wpforms-field-address": "wpforms-module__ZqAQqG__wpforms-field-address",
  "wpforms-field-container": "wpforms-module__ZqAQqG__wpforms-field-container",
  "wpforms-field-credit-card-code": "wpforms-module__ZqAQqG__wpforms-field-credit-card-code",
  "wpforms-field-credit-card-expiration": "wpforms-module__ZqAQqG__wpforms-field-credit-card-expiration",
  "wpforms-field-credit-card-name": "wpforms-module__ZqAQqG__wpforms-field-credit-card-name",
  "wpforms-field-credit-card-number": "wpforms-module__ZqAQqG__wpforms-field-credit-card-number",
  "wpforms-field-date-time-date-day": "wpforms-module__ZqAQqG__wpforms-field-date-time-date-day",
  "wpforms-field-date-time-date-month": "wpforms-module__ZqAQqG__wpforms-field-date-time-date-month",
  "wpforms-field-date-time-date-sep": "wpforms-module__ZqAQqG__wpforms-field-date-time-date-sep",
  "wpforms-field-date-time-date-year": "wpforms-module__ZqAQqG__wpforms-field-date-time-date-year",
  "wpforms-field-description": "wpforms-module__ZqAQqG__wpforms-field-description",
  "wpforms-field-description-before": "wpforms-module__ZqAQqG__wpforms-field-description-before",
  "wpforms-field-file-upload": "wpforms-module__ZqAQqG__wpforms-field-file-upload",
  "wpforms-field-hidden": "wpforms-module__ZqAQqG__wpforms-field-hidden",
  "wpforms-field-hp": "wpforms-module__ZqAQqG__wpforms-field-hp",
  "wpforms-field-html": "wpforms-module__ZqAQqG__wpforms-field-html",
  "wpforms-field-label": "wpforms-module__ZqAQqG__wpforms-field-label",
  "wpforms-field-label-inline": "wpforms-module__ZqAQqG__wpforms-field-label-inline",
  "wpforms-field-large": "wpforms-module__ZqAQqG__wpforms-field-large",
  "wpforms-field-limit-text": "wpforms-module__ZqAQqG__wpforms-field-limit-text",
  "wpforms-field-medium": "wpforms-module__ZqAQqG__wpforms-field-medium",
  "wpforms-field-number-slider": "wpforms-module__ZqAQqG__wpforms-field-number-slider",
  "wpforms-field-number-slider-hint": "wpforms-module__ZqAQqG__wpforms-field-number-slider-hint",
  "wpforms-field-phone": "wpforms-module__ZqAQqG__wpforms-field-phone",
  "wpforms-field-rating": "wpforms-module__ZqAQqG__wpforms-field-rating",
  "wpforms-field-rating-item": "wpforms-module__ZqAQqG__wpforms-field-rating-item",
  "wpforms-field-row": "wpforms-module__ZqAQqG__wpforms-field-row",
  "wpforms-field-select": "wpforms-module__ZqAQqG__wpforms-field-select",
  "wpforms-field-select-style-classic": "wpforms-module__ZqAQqG__wpforms-field-select-style-classic",
  "wpforms-field-select-style-modern": "wpforms-module__ZqAQqG__wpforms-field-select-style-modern",
  "wpforms-field-small": "wpforms-module__ZqAQqG__wpforms-field-small",
  "wpforms-field-stripe-credit-card-cardnumber": "wpforms-module__ZqAQqG__wpforms-field-stripe-credit-card-cardnumber",
  "wpforms-field-sublabel": "wpforms-module__ZqAQqG__wpforms-field-sublabel",
  "wpforms-file-upload-builder-modern": "wpforms-module__ZqAQqG__wpforms-file-upload-builder-modern",
  "wpforms-first": "wpforms-module__ZqAQqG__wpforms-first",
  "wpforms-first-half": "wpforms-module__ZqAQqG__wpforms-first-half",
  "wpforms-first-third": "wpforms-module__ZqAQqG__wpforms-first-third",
  "wpforms-five-sixths": "wpforms-module__ZqAQqG__wpforms-five-sixths",
  "wpforms-form": "wpforms-module__ZqAQqG__wpforms-form",
  "wpforms-four-fifths": "wpforms-module__ZqAQqG__wpforms-four-fifths",
  "wpforms-four-sixths": "wpforms-module__ZqAQqG__wpforms-four-sixths",
  "wpforms-has-error": "wpforms-module__ZqAQqG__wpforms-has-error",
  "wpforms-hide": "wpforms-module__ZqAQqG__wpforms-hide",
  "wpforms-highlighted": "wpforms-module__ZqAQqG__wpforms-highlighted",
  "wpforms-image-choices": "wpforms-module__ZqAQqG__wpforms-image-choices",
  "wpforms-image-choices-classic": "wpforms-module__ZqAQqG__wpforms-image-choices-classic",
  "wpforms-image-choices-image": "wpforms-module__ZqAQqG__wpforms-image-choices-image",
  "wpforms-image-choices-label": "wpforms-module__ZqAQqG__wpforms-image-choices-label",
  "wpforms-image-choices-modern": "wpforms-module__ZqAQqG__wpforms-image-choices-modern",
  "wpforms-info": "wpforms-module__ZqAQqG__wpforms-info",
  "wpforms-label-hide": "wpforms-module__ZqAQqG__wpforms-label-hide",
  "wpforms-last": "wpforms-module__ZqAQqG__wpforms-last",
  "wpforms-last-half": "wpforms-module__ZqAQqG__wpforms-last-half",
  "wpforms-last-third": "wpforms-module__ZqAQqG__wpforms-last-third",
  "wpforms-limit-text": "wpforms-module__ZqAQqG__wpforms-limit-text",
  "wpforms-list-2-columns": "wpforms-module__ZqAQqG__wpforms-list-2-columns",
  "wpforms-list-3-columns": "wpforms-module__ZqAQqG__wpforms-list-3-columns",
  "wpforms-list-inline": "wpforms-module__ZqAQqG__wpforms-list-inline",
  "wpforms-middle-third": "wpforms-module__ZqAQqG__wpforms-middle-third",
  "wpforms-mobile-full": "wpforms-module__ZqAQqG__wpforms-mobile-full",
  "wpforms-modern-hint": "wpforms-module__ZqAQqG__wpforms-modern-hint",
  "wpforms-modern-title": "wpforms-module__ZqAQqG__wpforms-modern-title",
  "wpforms-multiplechoice-2-columns": "wpforms-module__ZqAQqG__wpforms-multiplechoice-2-columns",
  "wpforms-multiplechoice-3-columns": "wpforms-module__ZqAQqG__wpforms-multiplechoice-3-columns",
  "wpforms-notice": "wpforms-module__ZqAQqG__wpforms-notice",
  "wpforms-notice-action": "wpforms-module__ZqAQqG__wpforms-notice-action",
  "wpforms-notice-actions": "wpforms-module__ZqAQqG__wpforms-notice-actions",
  "wpforms-one-fifth": "wpforms-module__ZqAQqG__wpforms-one-fifth",
  "wpforms-one-fourth": "wpforms-module__ZqAQqG__wpforms-one-fourth",
  "wpforms-one-half": "wpforms-module__ZqAQqG__wpforms-one-half",
  "wpforms-one-sixth": "wpforms-module__ZqAQqG__wpforms-one-sixth",
  "wpforms-one-third": "wpforms-module__ZqAQqG__wpforms-one-third",
  "wpforms-overlay": "wpforms-module__ZqAQqG__wpforms-overlay",
  "wpforms-page-button": "wpforms-module__ZqAQqG__wpforms-page-button",
  "wpforms-page-indicator": "wpforms-module__ZqAQqG__wpforms-page-indicator",
  "wpforms-page-indicator-page": "wpforms-module__ZqAQqG__wpforms-page-indicator-page",
  "wpforms-page-indicator-page-number": "wpforms-module__ZqAQqG__wpforms-page-indicator-page-number",
  "wpforms-page-indicator-page-progress": "wpforms-module__ZqAQqG__wpforms-page-indicator-page-progress",
  "wpforms-page-indicator-page-progress-wrap": "wpforms-module__ZqAQqG__wpforms-page-indicator-page-progress-wrap",
  "wpforms-page-indicator-page-title": "wpforms-module__ZqAQqG__wpforms-page-indicator-page-title",
  "wpforms-page-indicator-page-triangle": "wpforms-module__ZqAQqG__wpforms-page-indicator-page-triangle",
  "wpforms-page-next": "wpforms-module__ZqAQqG__wpforms-page-next",
  "wpforms-page-prev": "wpforms-module__ZqAQqG__wpforms-page-prev",
  "wpforms-pagebreak-center": "wpforms-module__ZqAQqG__wpforms-pagebreak-center",
  "wpforms-pagebreak-left": "wpforms-module__ZqAQqG__wpforms-pagebreak-left",
  "wpforms-pagebreak-right": "wpforms-module__ZqAQqG__wpforms-pagebreak-right",
  "wpforms-pagebreak-split": "wpforms-module__ZqAQqG__wpforms-pagebreak-split",
  "wpforms-preview-block": "wpforms-module__ZqAQqG__wpforms-preview-block",
  "wpforms-progress": "wpforms-module__ZqAQqG__wpforms-progress",
  "wpforms-recaptcha-container": "wpforms-module__ZqAQqG__wpforms-recaptcha-container",
  "wpforms-redirection-message": "wpforms-module__ZqAQqG__wpforms-redirection-message",
  "wpforms-required-label": "wpforms-module__ZqAQqG__wpforms-required-label",
  "wpforms-screen-reader-element": "wpforms-module__ZqAQqG__wpforms-screen-reader-element",
  "wpforms-selected": "wpforms-module__ZqAQqG__wpforms-selected",
  "wpforms-stripe-credit-card-hidden-input": "wpforms-module__ZqAQqG__wpforms-stripe-credit-card-hidden-input",
  "wpforms-stripe-element-invalid": "wpforms-module__ZqAQqG__wpforms-stripe-element-invalid",
  "wpforms-sublabel-hide": "wpforms-module__ZqAQqG__wpforms-sublabel-hide",
  "wpforms-submit": "wpforms-module__ZqAQqG__wpforms-submit",
  "wpforms-submit-container": "wpforms-module__ZqAQqG__wpforms-submit-container",
  "wpforms-submit-spinner": "wpforms-module__ZqAQqG__wpforms-submit-spinner",
  "wpforms-success": "wpforms-module__ZqAQqG__wpforms-success",
  "wpforms-text": "wpforms-module__ZqAQqG__wpforms-text",
  "wpforms-three-fifths": "wpforms-module__ZqAQqG__wpforms-three-fifths",
  "wpforms-three-fourths": "wpforms-module__ZqAQqG__wpforms-three-fourths",
  "wpforms-three-sixths": "wpforms-module__ZqAQqG__wpforms-three-sixths",
  "wpforms-title": "wpforms-module__ZqAQqG__wpforms-title",
  "wpforms-two-fifths": "wpforms-module__ZqAQqG__wpforms-two-fifths",
  "wpforms-two-fourths": "wpforms-module__ZqAQqG__wpforms-two-fourths",
  "wpforms-two-sixths": "wpforms-module__ZqAQqG__wpforms-two-sixths",
  "wpforms-two-thirds": "wpforms-module__ZqAQqG__wpforms-two-thirds",
  "wpforms-warning": "wpforms-module__ZqAQqG__wpforms-warning",
  "wpforms-with-files": "wpforms-module__ZqAQqG__wpforms-with-files",
});
